import { render, staticRenderFns } from "./GuestRegistration.vue?vue&type=template&id=52288228&scoped=true"
import script from "./GuestRegistration.vue?vue&type=script&lang=js"
export * from "./GuestRegistration.vue?vue&type=script&lang=js"
import style0 from "./GuestRegistration.vue?vue&type=style&index=0&id=52288228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52288228",
  null
  
)

export default component.exports